import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withKeys as _withKeys, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-27a22140"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "strengthList strengths-list-inner text-center" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "cs-accordion-anchor-child" }
const _hoisted_4 = {
  class: "text-center strengths-list-text",
  style: {"padding":"5px 15px 15px 15px"}
}
const _hoisted_5 = ["onClick", "onKeydown"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " ", -1))

import { ref, onMounted, watch } from "vue";
import { StrengthItemRatingApiModel } from "../../api-models";
import { DEFAULT_RATINGS, fontClass } from "./strengths-list-helpers";


export default /*#__PURE__*/_defineComponent({
  __name: 'strengths-list-inner',
  props: {
    ratings: { default: () => DEFAULT_RATINGS },
    showDevelopButton: { type: Boolean, default: false },
    initialActiveStrengthName: { default: "" },
    chosenStrengthName: { default: "" }
  },
  emits: ["choose-strength"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const activeStrength = ref("");

function click(name: string): void {
  if (name === activeStrength.value) {
    activeStrength.value = "";
  } else {
    activeStrength.value = name;
  }
}

watch(
  () => props.initialActiveStrengthName,
  (newValue: string) => {
    activeStrength.value = newValue;
  },
);

onMounted(() => {
  if (props.initialActiveStrengthName) {
    activeStrength.value = props.chosenStrengthName || props.initialActiveStrengthName;
  }
});

function chooseStrength(name: string): void {
  emit("choose-strength", name);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ol", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ratings, (rating, index) => {
      return (_openBlock(), _createElementBlock("li", {
        key: rating.strength.name
      }, [
        _createElementVNode("a", {
          onClick: ($event: any) => (click(rating.strength.name)),
          href: "javascript:void(0)",
          class: _normalizeClass(["a-block cs-accordion-anchor a-unstyled strengths-list-item-anchor", [_unref(fontClass)(index), activeStrength.value === rating.strength.name ? 'active' : '']])
        }, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(rating.strength.name), 1)
        ], 10, _hoisted_2),
        _createElementVNode("div", {
          class: _normalizeClass(["cs-accordion-panel strengths-list-item-panel", activeStrength.value === rating.strength.name ? 'active' : 'hidden'])
        }, [
          _createElementVNode("p", _hoisted_4, _toDisplayString(rating.strength.shortDefinition), 1),
          (_ctx.showDevelopButton)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "text-center",
                onClick: ($event: any) => (chooseStrength(rating.strength.name)),
                onKeydown: _withKeys(($event: any) => (chooseStrength(rating.strength.name)), ["enter"])
              }, [
                _createElementVNode("button", {
                  class: _normalizeClass(["btn btn-primary btn-lg", { active: rating.strength.name === _ctx.chosenStrengthName }]),
                  type: "button"
                }, " Develop " + _toDisplayString(rating.strength.name), 3),
                _hoisted_6
              ], 40, _hoisted_5))
            : _createCommentVNode("", true)
        ], 2)
      ]))
    }), 128))
  ]))
}
}

})